import PostScreen from './containers/postScreen'

export {default as PostScreenLayout} from './components/postScreenLayout'

export default PostScreen
